"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import api from "@/helper/api.interceptor";
import { Toast } from "@/components/Toast";
import { setInquiryPopupObj } from "@/store/slices/inquirySlice";
import { useDispatch, useSelector } from "react-redux";

export default function ContactUs({ ContactData }) {
  //   const navigate = useNavigate();
  const [inquiryObj, setInquiryObj] = useState({
    name: "",
    contact_no_display: "",
    contact_no: "",
    email: "",
    from_app: "true",
    master_user_id: "373",
    logged_in_master_user_id: "373",
    department: "",
    message: "",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  //   const [SeoData, setSeoData] = useState(contactSeoData || null);
  const [countryFlag, setCountryFlag] = useState(false);
  // const [countryList, setCountryList] = useState([]);
  const [search, setSearch] = useState("");
  const [errors, setErrors] = useState({});

  const countryList = useSelector((state) => state.inquiry.countryList);

  //   const seoMetaData = SeoData && {
  //     page_title: SeoData.seo_title || "Contact Us | Swati Procon",
  //     page_description: SeoData.seo_description,
  //     page_keywords: SeoData.seo_keywords,
  //     slug: SeoData.slug,
  //     image: SeoData.seo_image_full
  //       ? SeoData.seo_image_full.includes("?")
  //         ? `${SeoData.seo_image_full}&w=1280&h=640`
  //         : `${SeoData.seo_image_full}?w=1280&h=640`
  //       : "/images/sswati-procon.png",
  //   };

  const dispatch = useDispatch();

  useEffect(() => {
    // async function loadCountry() {
    //   try {
    //     const data = await CountryList();
    //     const filtered = data.filter((c) => c.phonecode !== "92");
    //     setCountryList(filtered);
    //   } catch (error) {
    //     console.error("Error loading countries", error);
    //   }
    // }
    // loadCountry();
    // console.log(contactSeoData);
    // let dataToUse;
    // if (SeoData != null) {
    //   console.log("Herer");
    //   dataToUse = SeoData;
    // } else {
    //   console.log("Herer22222222222222222");
    //   dataToUse = pageList.find((project) => project.slug === "contact-us");
    // }
    // if (dataToUse) {
    //   setSeoData(dataToUse);
    // }
    dispatch(setInquiryPopupObj(null));
  }, []);

  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.name)) {
      newErrors.name = "Name must contain only letters";
    }

    if (!inquiryObj.contact_no_display.trim()) {
      newErrors.contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.contact_no_display)) {
      newErrors.contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email)) {
      newErrors.email = "Invalid email format";
    }

    // ✅ Department validation
    if (!inquiryObj.department || inquiryObj.department === "") {
      newErrors.department = "Please select a department";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    setFormSubmitted(false);

    if (name === "name") {
      updatedValue = value.replace(/[0-9]/g, "");
    }
    if (name === "contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10);
    }

     if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCountrySelect = (phonecode, flag) => {
    setInquiryObj((prev) => ({
      ...prev,
      country: phonecode,
      flag,
    }));
    setCountryFlag(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const contact_no = inquiryObj.country + " " + inquiryObj.contact_no_display;
    const finalInquiry = {
      ...inquiryObj,
      contact_no,
    };

    try {
      const response = await api.ContactInquiry(finalInquiry);
      //   console.log("Inquiry submitted:", response);

      //   navigate(`/contact-us/thankyou`, {
      //     state: {
      //       name: "Contact Us",
      //     },
      //   });

      // Reset form
      if (response.success == 1) {
        setInquiryObj((prev) => ({
          ...prev,
          name: "",
          contact_no_display: "",
          contact_no: "",
          email: "",
          message: "",
        }));
        setErrors({});

        // alert("Inquiry submitted successfully!");
      }
      setFormSubmitted(false);

      Toast(response.message);
    } catch (err) {
      console.error("Submission error:", err);
      setFormSubmitted(false);
    }
  };
  const [isMobilescreen, setMobilescreen] = useState(false);

  useEffect(() => {
    // let contactUsData = {};
    // if (contactUsData == null) {
    // contactData = pageList.find((page) => page.slug == 'contact-us');
    // setAboutUs(contactUsData);
    // }
    if (window.innerWidth <= 767) setMobilescreen(true);
  }, []);
  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
      <div
        className="reecosys-main-wrapper"
        id="reecosys-main-wrapper"
        onClick={() => {
          setCountryFlag(false);
        }}
      >
        <div
          id="reecosys-contact-us-wrapper"
          className="relative inner-flex-big inner-flex"
        >
          <section className="reecosys-section relative">
            <div className="common-listing-banner relative">
              <img
                src="https://www.reecosys.com/api/image-tool/index.php?src=https://www.reecosys.com/assets/uploads/pages/banner/banner_1777802935_46.png&w=1920&h=750"
                alt="Desktop Banner"
                className="hide-tab-mobile"
              />
              <img
                src="https://www.reecosys.com/api/image-tool/index.php?src=https://www.reecosys.com/assets/uploads/pages/banner/banner_1777802935_46.png&h=1500&w=1920&q=100"
                alt="Mobile Banner"
                className="visible-tab-mobile"
                style={{ height: "unset" }}
              />
            </div>
            <div className="black_overlay"></div>
          </section>
          <section className="reecosys-section section-padding-bottom relative">
            <div className="mini-container">
              <div className="page-list-2-col-grid">
                <div className="inner-flex ">
                  <div className="inner-flex">
                    <div className="section-title">
                      <h1 className="text-uppercase">Contact Us</h1>
                    </div>
                    <div className="section-paragraph ">
                      <p>{ContactData.contact_list[0].address}</p>
                    </div>
                    <div className="">
                      <a
                        href={ContactData.contact_list[0].map_url}
                        target="_blank"
                      >
                        <button
                          className={`reecosys-template-button button-style-primary  ${
                            isMobilescreen ? "w100" : ""
                          }`}
                        >
                          <div className="map-icon">
                            <span className="material-symbols-outlined">
                              location_on
                            </span>
                          </div>
                          <p>View on map</p>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="project_detail_inquiry_form" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="600"> */}
                <div
                  className=""
                  data-aos="fade-in"
                  data-aos-duration="1000"
                  data-aos-delay="600"
                >
                  <form
                    id="inquiry_form_detail"
                    name="inquiry_form_detail"
                    className="inner-flex"
                    onSubmit={handleSubmit}
                  >
                    <div className="form_wrapper contact_form">
                      <div className="contact_lable">
                        <span className="material-symbols-outlined icon-form-control">
                          person
                        </span>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          className={`form-control form-control-iconpad ${
                            inquiryObj.name ? "ng-not-empty" : "ng-empty"
                          } ${errors.name ? "ng-invalid" : "ng-valid"} ${
                            inquiryObj.name ? "ng-touched" : ""
                          } ${formSubmitted && errors.name ? "error" : ""}`}
                          value={inquiryObj.name}
                          onChange={handleChange}
                          tabIndex="1"
                        />
                        <label className="md-lable" htmlFor="name">
                          Name
                        </label>
                        <div className="valid-icon-of-form">
                          <img
                            loading="lazy"
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                            alt="valid"
                          />
                        </div>
                      </div>

                      <div className="contact_lable">
                        <span className="material-symbols-outlined icon-form-control">
                          alternate_email
                        </span>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          className={`form-control form-control-iconpad ${
                            inquiryObj.email ? "ng-not-empty" : "ng-empty"
                          } ${formSubmitted && errors.email ? "error" : ""} ${
                            errors.email ? "ng-invalid" : "ng-valid"
                          } ${inquiryObj.email ? "ng-touched" : ""}`}
                          value={inquiryObj.email}
                          onChange={handleChange}
                          tabIndex="3"
                        />
                        <label className="md-lable" htmlFor="email">
                          Email
                        </label>
                        <div className="valid-icon-of-form">
                          <img
                            loading="lazy"
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                            alt="valid"
                          />
                        </div>
                      </div>

                      {/* Contact Number */}
                      <div className="contact_lable relative">
                        <span className="material-symbols-outlined icon-form-control">
                          dialpad
                        </span>
                        <input
                          id="contact_no_display"
                          name="contact_no_display"
                          type="text"
                          className={`form-control contact-form form-control-iconpad ${
                            inquiryObj.contact_no_display
                              ? "ng-not-empty"
                              : "ng-empty"
                          } ${
                            formSubmitted && errors.contact_no_display
                              ? "error"
                              : ""
                          } ${
                            !errors.contact_no_display &&
                            inquiryObj.contact_no_display.length === 10
                              ? "ng-valid"
                              : "ng-invalid"
                          } ${
                            inquiryObj.contact_no_display ? "ng-touched" : ""
                          }`}
                          value={inquiryObj.contact_no_display}
                          onChange={handleChange}
                          minLength="10"
                          maxLength="10"
                          tabIndex="2"
                        />
                        <label
                          className="md-lable contact_code"
                          htmlFor="contact_no_display"
                        >
                          Mobile Number
                        </label>
                        <div className="valid-icon-of-form">
                          <img
                            loading="lazy"
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                            alt="valid"
                          />
                        </div>
                        <div className="conatct_number_input">
                          <div
                            className="country_code_data"
                            onClick={(e) => {
                              setCountryFlag(true);
                              e.stopPropagation();
                            }}
                          >
                            <div className="contact_country_flag">
                              <img
                                loading="lazy"
                                src={inquiryObj.flag}
                                alt="country-flag"
                              />
                            </div>
                            <div>&nbsp;+{inquiryObj.country}</div>
                            <div>
                              <i
                                className="fa fa-angle-down"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`country_code_list_data ${
                            countryFlag ? "active" : ""
                          }`}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="search_c-code">
                            <input
                              type="text"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search"
                            />
                          </div>
                          <ul>
                            {countryList
                              .filter(
                                (item) =>
                                  item.phonecode.toString().includes(search) ||
                                  item.nicename
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                              )
                              .map((item, index) => (
                                <li
                                  key={`${item.phonecode}-${item.nicename}-${index}`}
                                >
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCountrySelect(
                                        item.phonecode,
                                        item.flag
                                      );
                                    }}
                                  >
                                    <div>
                                      <img src={item.flag} alt="country" />
                                    </div>
                                    <span className="display_country_code">
                                      +{item.phonecode}
                                    </span>{" "}
                                    {item.nicename}
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="contact_lable select_option select_apr relative">
                        <select
                          name="department"
                          defaultValue=""
                          onChange={handleChange}
                          className={`form-control 
                                            ${
                                              inquiryObj.department
                                                ? "ng-not-empty"
                                                : "ng-empty"
                                            } ${
                            errors.department ? "ng-invalid" : "ng-valid"
                          } ${inquiryObj.department ? "ng-touched" : ""} ${
                            formSubmitted && errors.department ? "error" : ""
                          }`}
                          id="department"
                          tabIndex="4"
                        >
                          <option
                            value=""
                            disabled
                            className="gray-color"
                            style={{ display: "none" }}
                          ></option>
                          {ContactData.contact_list[0].details &&
                            ContactData.contact_list[0].details.map(
                              (depertment_data, index) => (
                                <option
                                  key={index}
                                  value={depertment_data.department}
                                  className="capitalize"
                                >
                                  {depertment_data.department}
                                </option>
                              )
                            )}
                        </select>
                        <label
                          className="md-lable department_label"
                          htmlFor="department"
                        >
                          Department
                        </label>

                        <div className="fa-icon">
                          <span className="material-symbols-outlined">
                            keyboard_arrow_down
                          </span>
                        </div>
                      </div>

                      {/* Comments */}
                      <div className="contact_lable commentbox">
                        <span className="material-symbols-outlined icon-form-control">
                          chat_bubble
                        </span>
                        <textarea
                          id="message"
                          name="message"
                          type="text"
                          className={`form-control form-control-iconpad ${
                            inquiryObj.message ? "ng-not-empty" : "ng-empty"
                          } ${inquiryObj.message ? "ng-touched" : ""}`}
                          value={inquiryObj.message}
                          onChange={handleChange}
                          rows="4"
                          tabIndex="5"
                        ></textarea>
                        <label
                          className="md-lable contact_us_form"
                          htmlFor="message"
                        >
                          Comments
                        </label>
                      </div>
                      <p className="relative check_box_error get_update_text align_center">
                        <input
                          className="get_update_checkbox"
                          type="checkbox"
                          id="agree_tandc"
                          tabIndex={6}
                          name="agree_tandc"
                          aria-required="true"
                          aria-invalid="true"
                        />
                        <label className="darkgray-font" htmlFor="agree_tandc">
                          Keep me updated.
                        </label>
                      </p>

                      <div className="submit-button border-div-venus-wrapper submit-button-contact form_button">
                        <button
                          className="reecosys-template-button button-style-primary w100"
                          type="submit"
                          tabIndex={7}
                        >
                          {formSubmitted &&
                          Object.values(errors).every((err) => err === "") ? (
                            <span>Please Wait...</span>
                          ) : (
                            <span>Submit</span>
                          )}
                          <span className="material-symbols-outlined">
                            arrow_forward
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
